import {
    SortingAndButtonsAboveTable
} from "../../../../../../../shared/components/sorting-and-buttons-above-table/SortingAndButtonsAboveTable";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import FilterHistory from "../../../../../../../shared/components/filter-history/FilterHistory";
import {getConsipSimDaAttivare} from "../../../../../../../store/ordini-consip/actions";
import SimDaAttivareTable from "./sim-da-attivare-table/SimDaAttivareTable";
import DaAttivareFilter from "../../../../sim/tabs/da-attivare/da-attivare-filter/DaAttivareFilter";
import {updateObject} from "../../../../../../../shared/utils/updateObject";
import {
    daAttivareSortingOptions,
    filterDaAttivare
} from "../../../../sim/tabs/da-attivare/da-attivare-filter/DaAttivareFilterHelper";
import {AttivaSimDialog} from "./sim-da-attivare-dialogs/attiva-sim-dialog/AttivaSimDialog";
import AttivaSimSecondariaDialog from "./sim-da-attivare-dialogs/attiva-sim-secondaria/AttivaSimSecondariaDialog";

const SimDaAttivare = () => {
    const dispatch = useDispatch()
    const [selectedDaAttivare, setSelectedDaAttivare] = useState([]);
    const [areAllSelected, setAreAllSelected] = useState(false);

    const tableData = useSelector((state) => state.ordiniConsipReducer.simDaAttivare.data)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [sort, setSort] = useState(`${daAttivareSortingOptions[0].value},desc`)
    const [filterHistory, setFilterHistory] = useState(filterDaAttivare)
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId)

    const [isAttivaSimDialogOpen, setIsAttivaSimDialogOpen] = useState(false)
    const [openSimSecondariaDialog, setOpenSimSecondariaDialog] = useState(false);

    useEffect(() => {
        dispatch(getConsipSimDaAttivare(integrationId, sort, page, rowsPerPage, filterHistory))
    }, [dispatch, page, sort, rowsPerPage, filterHistory, integrationId])

    const handleFilterSearch = (name, value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [name]: {
                ...currentFilterHistory[name],
                value: value
            }
        }))
    }

    const handleFilterSelectsSearch = (value) => {
        setPage(0);
        setFilterHistory(prevFilterHistory => updateObject(prevFilterHistory, value))
    }

    const handleTablePaginationChange = (page, rowsPerPage) => {
        setPage(page);
        setRowsPerPage(rowsPerPage);
    }

    const handleRemoveBadge = (key, type, index) => {
        setPage(0);
        setFilterHistory(filterHistory => updateObject(filterHistory, {
            [key]: {
                ...filterHistory[key],
                value: type === "primitive" ? "" : [...filterHistory[key].value].filter((i, idx) => idx !== index)
            }
        }))
    }

    const handleResetFilter = () => {
        setPage(0);
        setFilterHistory(filterDaAttivare);
    }

    const daAttivareMenuItems = [
        {
            text: "Attiva SIM",
            handleClick: () => setIsAttivaSimDialogOpen(true),
            disabled: selectedDaAttivare.filter(s => s.wrenchDto.showWrench).length
        },
        {
            text: "Attiva SIM secondaria",
            handleClick: () => setOpenSimSecondariaDialog(true),
            disabled: selectedDaAttivare.length > 1 || selectedDaAttivare.filter(s => s.wrenchDto.showWrench).length
        },
    ];

    const handleAnnullaClick = () => {
        setSelectedDaAttivare([])
        setAreAllSelected(false)
    }

    return (
        <>
            <h2>SIM incluse nell’ordine non ancora attivate</h2>

            <DaAttivareFilter handleSearchIcon={handleFilterSearch}
                              filter={filterHistory}
                              handleSelectSearch={handleFilterSelectsSearch}/>

            <FilterHistory filter={filterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>

            <SortingAndButtonsAboveTable sortingValue={sort}
                                         changeSortingCriteria={setSort}
                                         sortingCriteria={daAttivareSortingOptions}
                                         dataLength={tableData.length}
                                         menuItems={daAttivareMenuItems}
                                         selectedData={areAllSelected ? tableData.count : selectedDaAttivare.length}
                                         handleAnnullaClick={handleAnnullaClick}/>

            <SimDaAttivareTable selected={selectedDaAttivare}
                                setSelected={setSelectedDaAttivare}
                                page={page}
                                count={tableData.count}
                                rowsPerPage={rowsPerPage}
                                sort={sort}
                                filter={filterHistory}
                                handlePaginationChange={handleTablePaginationChange}
                                areAllSelected={areAllSelected}
                                setAreAllSelected={setAreAllSelected}/>

            {isAttivaSimDialogOpen ?
                <AttivaSimDialog
                    selectedSims={selectedDaAttivare}
                    handleDialogClose={() => setIsAttivaSimDialogOpen(false)}
                    open={isAttivaSimDialogOpen}/>
                : null}
            {openSimSecondariaDialog ?
                <AttivaSimSecondariaDialog
                    selectedSims={selectedDaAttivare}
                    open={openSimSecondariaDialog}
                    handleDialogClose={() => setOpenSimSecondariaDialog(false)}/>
                : null}
        </>
    )
};

export default SimDaAttivare;
